<mat-card appearance="outlined" id="mat-card">
  <ng-content></ng-content>
</mat-card>
